// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a0708434","453":"716a839d","455":"7b35be26","977":"73299bfd"}[chunkId] + ".chunk.js";
};